import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[dropEmitter]'
})
export class DocumentDropEmitterDirective {
  @Output() dropEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() dragEnterEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() dragEndEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() dragLeaveEmitter: EventEmitter<any> = new EventEmitter<any>();

  public isFile = false;
  constructor(private _eref: ElementRef) { }

  @HostListener('dragenter', ['$event'])
  ondragenter(event) {
    if (
      event.dataTransfer.types[0] === 'Files' ||
      event.dataTransfer.types[1] === 'Files'
    ) {
      this.isFile = true;
      event.preventDefault();
      this.dragEnterEmitter.emit(event);
    } else {
      this.isFile = false;
    }
  }

  @HostListener('dragend', ['$event'])
  ondragend(event) {
    if (this.isFile) {
      event.preventDefault();
      this.dragEndEmitter.emit(event);
    }
  }

  @HostListener('drop', ['$event'])
  ondrop(event) {
    if (this.isFile) {
      event.preventDefault();
      this.dropEmitter.emit(event);
    }
  }

  @HostListener('dragover', ['$event'])
  ondragover(event) {
    if (this.isFile) {
      event.preventDefault();
    }
  }

  @HostListener('dragleave', ['$event'])
  ondragleave(event) {
    if (this.isFile) {
      event.preventDefault();
      this.dragLeaveEmitter.emit(event);
    }
  }
}
